import { ConversationPrompt } from '../data';

function timeMs(prompt: ConversationPrompt): number {
  const stamp = prompt.created_timestamp;
  const ms = stamp instanceof Date ? stamp.getTime() : NaN;
  return Number.isNaN(ms) ? 0 : ms;
}

/** Oldest first. Same instant: lower id, then the user turn before the assistant placeholder. */
export function comparePrompts(a: ConversationPrompt, b: ConversationPrompt): number {
  const dt = timeMs(a) - timeMs(b);
  if (dt !== 0) return dt;
  const ia = a.id ?? Number.MAX_SAFE_INTEGER;
  const ib = b.id ?? Number.MAX_SAFE_INTEGER;
  if (ia !== ib) return ia - ib;
  if (a.user_created !== b.user_created) return a.user_created ? -1 : 1;
  return 0;
}

export function sortPrompts(prompts: ConversationPrompt[]): ConversationPrompt[] {
  return [...prompts].sort(comparePrompts);
}
